import React, { useState } from 'react';
import { useStyles } from '@webapps/styles';
import { ExitToApp as ExitToAppIcon } from '@material-ui/icons';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

export default function SignupCourse({ onClose }) {
  const { classes } = useStyles(styles);
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      case 5:
        return <Step5 />;
      default:
        return <div>Étape non trouvée</div>;
    }
  };

  const Stepper = () => (
    <div className={classes['framerDiv6']}>
      {[1, 2, 3, 4, 5].map((step) => (
        <React.Fragment key={step}>
          <div
            className={
              currentStep >= step
                ? classes['framerDiv7']
                : classes['framerDiv9']
            }
          >
            <div className={classes['framerP3']}>{step}</div>
          </div>
          {step < 5 && (
            <div
              className={
                currentStep > step
                  ? classes['framerDiv8']
                  : classes['framerDiv10']
              }
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className={classes['framerDiv']}>
      <div className={classes['framerDiv2']}>
        <img
          className={classes['framerImg']}
          src="https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png"
          srcSet="https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png?scale-down-to=512 512w,https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png?scale-down-to=2048 2048w,https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png?scale-down-to=4096 4096w,https://framerusercontent.com/images/tDQ7Nq9H0aLHTI6DxPPX28HZSj8.png 4479w"
          sizes="373px"
          alt=""
        />
        <div className={classes['framerDiv3']}>
          <div className={classes['framerP']}>👋 Bonjour Michou,</div>
          <div className={classes['framerP']}>Bienvenue sur Linkpick</div>
          <div className={classes['framerP2']}>
            Un profil optimisé génère un maximum d'opportunités
          </div>
        </div>
        <img
          className={classes['framerImg2']}
          src="https://framerusercontent.com/images/q447mpr61veIE6NZMphhE6IrTo.png"
          srcSet="https://framerusercontent.com/images/q447mpr61veIE6NZMphhE6IrTo.png?scale-down-to=512 512w,https://framerusercontent.com/images/q447mpr61veIE6NZMphhE6IrTo.png 524w"
          sizes="118px"
          alt=""
        />
        <img
          className={classes['framerImg3']}
          src="https://framerusercontent.com/images/coEtXY8Nj7bVBsy9Zvh55FwADI0.png"
          alt=""
        />
        <img
          className={classes['framerImg4']}
          src="https://framerusercontent.com/images/9ACmHoDF3KdM6R4gUr7XE9Lex6Y.png"
          srcSet="https://framerusercontent.com/images/9ACmHoDF3KdM6R4gUr7XE9Lex6Y.png?scale-down-to=512 512w,https://framerusercontent.com/images/9ACmHoDF3KdM6R4gUr7XE9Lex6Y.png 545w"
          sizes="72px"
          alt=""
        />
        <img
          className={classes['framerImg5']}
          src="https://framerusercontent.com/images/CPoW05sisjSCyWZKiyn17IfgM.png"
          alt=""
        />
        <img
          className={classes['framerImg6']}
          src="https://framerusercontent.com/images/CPoW05sisjSCyWZKiyn17IfgM.png"
          alt=""
        />
      </div>
      <div className={classes['framerDiv5']}>
        <Stepper />
        {renderStepContent()}
        <div className={classes['framerDiv14']}>
          <div
            className={classes['framerDiv15']}
            onClick={onClose}
            style={{ cursor: 'pointer' }}
          >
            <ExitToAppIcon className={classes['framerIcon2']} />
            <div className={classes['framerP10']}>Ignorer pour le moment</div>
          </div>
          <div className={classes['framerButton3']} onClick={handleNext}>
            <div className={classes['framerP7']}>Etape suivante</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = ({ spacing }) => ({
  framerDiv: {
    alignContent: 'center',
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    boxShadow: '#1526524d 20px 20px 20px 0px',
    display: 'flex',
    flexDirection: 'column',
    height: 'min-content',
    position: 'relative',
    width: '880px',
    overflow: 'visible',
    placeItems: 'center',
    zIndex: 1000,
  },
  framerDiv2: {
    WebkitMaskPositionX: '0%',
    WebkitMaskPositionY: '0%',
    alignItems: 'flex-start',
    backgroundColor: '#f3f7ff',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: 'min-content',
    justifyContent: 'flex-start',
    maskClip: 'border-box',
    maskComposite: 'add',
    maskImage: 'linear-gradient(0deg, #000000 0%, #000000 100%)',
    maskMode: 'match-source',
    maskOrigin: 'border-box',
    maskRepeat: 'repeat',
    paddingBottom: '48px',
    paddingLeft: '48px',
    paddingRight: '48px',
    paddingTop: '48px',
    position: 'relative',
    width: '100%',
    gap: '30px',
    overflow: 'visible',
  },
  framerImg: {
    aspectRatio: '2.15544 / 1',
    position: 'absolute',
    right: '55px',
    top: '17px',
    width: '373px',
    overflow: 'visible',
  },
  framerDiv3: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: '10px',
    width: '100%',
  },
  framerP: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'left',
    color: '#152652',
  },
  framerP2: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    textAlign: 'left',
    color: '#5d75a8',
  },
  framerImg2: {
    aspectRatio: '2.13008 / 1',
    position: 'absolute',
    right: '-24px',
    top: '35px',
    width: '118px',
    overflow: 'visible',
  },
  framerImg3: {
    aspectRatio: '2.02721 / 1',
    left: '342px',
    opacity: '0.6',
    position: 'absolute',
    top: '51px',
    width: '67px',
    overflow: 'visible',
  },
  framerImg4: {
    aspectRatio: '2.2428 / 1',
    left: '51%',
    position: 'absolute',
    top: '26px',
    transform: 'translateX(-50%)',
    width: '72px',
    overflow: 'visible',
  },
  framerImg5: {
    aspectRatio: '1.93277 / 1',
    left: '280px',
    opacity: '0.4',
    position: 'absolute',
    top: '34px',
    width: '54px',
    overflow: 'visible',
  },
  framerImg6: {
    aspectRatio: '1.93277 / 1',
    opacity: '0.4',
    position: 'absolute',
    right: '117px',
    top: '35px',
    width: '54px',
    overflow: 'visible',
  },
  framerDiv5: {
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: 'min-content',
    justifyContent: 'flex-start',
    paddingBottom: '48px',
    paddingLeft: '48px',
    paddingRight: '48px',
    paddingTop: '48px',
    position: 'relative',
    width: '100%',
    gap: '30px',
    overflow: 'hidden',
  },
  framerDiv6: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 'min-content',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
    gap: '4px',
    overflow: 'hidden',
  },
  framerDiv7: {
    backgroundColor: '#0060f9',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '20px',
    height: '24px',
    padding: '6px',
    width: '24px',
  },
  framerP3: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: '600',
    color: '#ffffff',
  },
  framerDiv8: {
    backgroundColor: '#0060f9',
    borderRadius: '10px',
    flexGrow: '1',
    height: '4px',
    position: 'relative',
    overflow: 'hidden',
  },
  framerDiv9: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#c0d9ff',
    borderRadius: '20px',
    height: '24px',
    padding: '6px',
    width: '24px',
  },
  framerDiv10: {
    backgroundColor: '#c0d9ff',
    borderRadius: '10px',
    flexGrow: '1',
    height: '4px',
    position: 'relative',
    overflow: 'hidden',
  },
  framerP7: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '13.5px',
    fontWeight: '500',
    textAlign: 'center',
    color: '#ffffff',
  },
  framerDiv14: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 'min-content',
    justifyContent: 'flex-end',
    position: 'relative',
    width: '100%',
    gap: '24px',
    overflow: 'hidden',
  },
  framerDiv15: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    position: 'relative',
    gap: '6px',
    cursor: 'pointer',
    '&:hover': {
      '& $framerIcon2': {
        fill: '#0060f9',
      },
      '& $framerP10': {
        color: '#0060f9',
      },
    },
  },
  framerIcon2: {
    height: '24px',
    position: 'relative',
    width: '24px',
    fill: '#5d75a8',
  },
  framerP10: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    color: '#5d75a8',
  },
  framerButton3: {
    backgroundColor: '#0060f9',
    borderRadius: '40px',
    display: 'flex',
    flexDirection: 'row',
    height: '40px',
    paddingBottom: '5px',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '5px',
    position: 'relative',
    gap: '10px',
    placeItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#004ac1',
    },
  },
});
